import Nullstack from 'nullstack';
export default function IconMoodSmileBeam({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-mood-smile-beam",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
  }), "   ", Nullstack.element("path", {
    d: "M10 10c-.5 -1 -2.5 -1 -3 0"
  }), "   ", Nullstack.element("path", {
    d: "M17 10c-.5 -1 -2.5 -1 -3 0"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 15a3.5 3.5 0 0 1 -5 0"
  }), " ");
}